import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "select-item",
  onmouseover: "this.children[1].classList.add('hover')",
  onmouseleave: "this.children[1].classList.remove('hover');this.children[1].classList.remove('pressed')",
  onmousedown: "this.children[1].classList.add('pressed')",
  onmouseup: "this.children[1].classList.remove('pressed')"
}
const _hoisted_3 = ["data-qe-id"]
const _hoisted_4 = ["value", "selected", "data-qe-id"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "select-arrow icf-arrowBottom" }, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'CSelect',
  props: {
    options: {},
    label: {},
    qeId: {},
    value: {}
  },
  emits: ['input'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

function update(event: Event) {
  emit('input', (event.target as HTMLInputElement).value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        onChange: update,
        "data-qe-id": _ctx.qeId
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            value: item.value,
            key: item.value,
            selected: item.value == _ctx.value,
            "data-qe-id": `${_ctx.qeId}-option--${item.value}`
          }, _toDisplayString(item.name), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3),
      _hoisted_5
    ])
  ]))
}
}

})